import { useEffect, useState } from 'react';
import { SampleMetaSchema, type SampleMeta } from '@tonist/shared';
import { PageShell } from '../components/PageShell';

export function CreditsRoute() {
  const [samples, setSamples] = useState<SampleMeta[] | null>(null);
  const [md, setMd] = useState<string | null>(null);
  useEffect(() => {
    fetch('/samples/manifest.json').then(async (r) => {
      if (!r.ok) return [];
      const j = await r.json() as { samples?: unknown[] };
      return (j.samples ?? []).map((s) => SampleMetaSchema.safeParse(s)).filter((p) => p.success).map((p) => p.data);
    }).then(setSamples).catch(() => setSamples([]));
    fetch('/CREDITS.md').then(async (r) => {
      const t = r.ok ? await r.text() : '';
      return /^\s*<!doctype|^\s*<html/i.test(t) ? '' : t; // SPA fallback returns index.html
    }).then((t) => setMd(t || null)).catch(() => setMd(null));
  }, []);
  return (
    <PageShell eyebrow="Credits" title="Sounds and their makers">
      <div className="prose">
        <p>Tonist is not sold or monetised. Built-in sounds are Creative Commons or public domain recordings; where a sample is CC-BY-NC it is marked NC. Every drone you publish carries the credit lines of the samples it uses.</p>
      </div>
      {samples === null ? <div className="hint">Loading…</div> : samples.length === 0 ? <div className="notice">No sample manifest is available in this build.</div> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 13 }}>
            <thead><tr>{['Sample', 'Family', 'Credit', 'License', 'Source'].map((h) => <th key={h} style={{ textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid var(--control-line)', color: 'var(--fg-dim)', fontWeight: 500 }}>{h}</th>)}</tr></thead>
            <tbody>
              {samples.map((s) => (
                <tr key={s.id}>
                  <td style={{ padding: '8px 10px' }}>{s.name}</td>
                  <td style={{ padding: '8px 10px' }}>{s.family}</td>
                  <td style={{ padding: '8px 10px' }}>{s.credit}</td>
                  <td style={{ padding: '8px 10px' }}>{s.license}{s.nc ? ' (NC)' : ''}</td>
                  <td style={{ padding: '8px 10px' }}>{s.sourceUrl ? <a href={s.sourceUrl} rel="noreferrer">link</a> : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {md && <details className="disclosure glass panel"><summary>CREDITS.md</summary><pre style={{ whiteSpace: 'pre-wrap', fontSize: 12.5, color: 'var(--fg-dim)' }}>{md}</pre></details>}
      <div className="prose">
        <p>The sitar was recorded for this project. Fonts: Yatra One, Inter and Noto Serif Tibetan, served by Google Fonts under the SIL Open Font License.</p>
      </div>
    </PageShell>
  );
}
